import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { arrayInsert, arrayRemove, formValueSelector } from 'redux-form';

import SecondPage from './SecondPage';
import { selectCategory as selectCategoryAction } from './redux/actions/uiActions';

export function SecondPageContainer({
  categoryGroups,
  myArrayInsert,
  myArrayRemove,
  nextPage,
  previousPage,
  selectCategory,
  selectedCategory,
  selectedCategoryIds
}) {
  return (
    <SecondPage
      myArrayInsert={myArrayInsert}
      myArrayRemove={myArrayRemove}
      categoryGroups={categoryGroups}
      onSubmit={nextPage}
      previousPage={previousPage}
      selectCategory={selectCategory}
      selectedCategory={selectedCategory}
      selectedCategoryIds={selectedCategoryIds}
    />
  );
}

SecondPageContainer.propTypes = {
  categoryGroups: arrayOf(shape({})).isRequired,
  myArrayInsert: func.isRequired,
  myArrayRemove: func.isRequired,
  nextPage: func.isRequired,
  previousPage: func.isRequired,
  selectCategory: func.isRequired,
  selectedCategory: shape({
    label: string,
    value: number
  }).isRequired,
  selectedCategoryIds: arrayOf(number).isRequired
};

const mapStateToProps = ({ ui: { selectedCategory }, ...state }) => {
  const selector = formValueSelector('partnerSubmissionForm');
  const selectedCategoryIds = selector(state, 'category_ids');
  return { selectedCategory, selectedCategoryIds };
};

export default connect(mapStateToProps, {
  myArrayInsert: arrayInsert,
  myArrayRemove: arrayRemove,
  selectCategory: selectCategoryAction
})(SecondPageContainer);
